import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';

import { ClientDataComponent } from './client-data.component';
import { HeaderModule } from '../../../shared/component/common/header/header.module';
import { ButtonModule } from '../../../shared/component/common/button/button.module';
import { LabelModule } from '../../../shared/component/common/label/label.module';
import { DataListModule } from '../../../shared/component/common/data-list/data-list.module';
import { AlertMessageModule } from './../../../shared/component/common/alert-message/alert-message.module';
import { RetryModule } from '../../../shared/component/common/retry/retry.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    HeaderModule,
    ButtonModule,
    LabelModule,
    DataListModule,
    AlertMessageModule,
    RetryModule,
  ],
  declarations: [ClientDataComponent]
})
export class ClientDataComponentModule {}
